var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignedCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15986_21638)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.167 1C11.5475 1 12.6667 2.11951 12.667 3.5V3.77832H12.9453C14.9395 3.77853 16.5557 5.39541 16.5557 7.38965V8.94531C16.5557 9.40537 16.1827 9.77832 15.7227 9.77832C15.2626 9.77832 14.8896 9.40537 14.8896 8.94531V7.38965C14.8896 6.31589 14.019 5.44552 12.9453 5.44531H4.61133C3.53757 5.44546 2.66699 6.31585 2.66699 7.38965V12.9453C2.6672 14.0189 3.53769 14.8895 4.61133 14.8896H8.94531C9.40537 14.8896 9.77832 15.2626 9.77832 15.7227C9.77832 16.1827 9.40537 16.5557 8.94531 16.5557H4.61133C2.61722 16.5555 1.00021 14.9394 1 12.9453V7.38965C1 5.39538 2.61709 3.77847 4.61133 3.77832H4.88965V3.5C4.88991 2.11951 6.0091 1 7.38965 1H10.167ZM7.38965 2.66699C6.92957 2.66699 6.55593 3.03999 6.55566 3.5V3.77832H11V3.5C10.9997 3.03999 10.6271 2.66699 10.167 2.66699H7.38965Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2227 7.71484C13.6565 7.56172 14.1328 7.78897 14.2861 8.22266C14.4393 8.65649 14.212 9.13277 13.7783 9.28613L13.4932 9.38672C12.3099 9.80434 11.0848 10.0596 9.85059 10.1533C9.87572 10.2461 9.88965 10.3446 9.88965 10.4453V11C9.88965 11.6136 9.39194 12.1113 8.77832 12.1113C8.16467 12.1113 7.66699 11.6136 7.66699 11V10.4453C7.66699 10.3446 7.68092 10.2461 7.70605 10.1533C6.47188 10.0596 5.24671 9.80432 4.06348 9.38672L3.77832 9.28613C3.34457 9.13281 3.11738 8.65653 3.27051 8.22266C3.42385 7.78909 3.89926 7.56193 4.33301 7.71484L4.61816 7.81543C7.31018 8.76549 10.2465 8.76552 12.9385 7.81543L13.2227 7.71484Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9663 12.9052C18.1832 12.6883 18.1832 12.3365 17.9663 12.1195L16.7878 10.941C16.5708 10.7241 16.219 10.7241 16.0021 10.941L14.9386 12.0045L16.9028 13.9687L17.9663 12.9052Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1171 14.7544L14.1529 12.7902L11.4319 15.5113C11.017 15.9261 10.783 16.4882 10.781 17.0749L10.7783 17.8502C10.7778 18.0044 10.9029 18.1295 11.0571 18.129L11.8324 18.1263C12.4191 18.1243 12.9812 17.8903 13.3961 17.4754L16.1171 14.7544Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15986_21638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignedCustomer);
export default __webpack_public_path__ + "static/media/iconSignedCustomer.df4719f7d39897207c82a7411fd37fec.svg";
export { ForwardRef as ReactComponent };